/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiOutlinedInputComponent = {
  defaultProps?: ComponentsProps['MuiOutlinedInput'];
  styleOverrides?: ComponentsOverrides['MuiOutlinedInput'];
  variants?: ComponentsVariants['MuiOutlinedInput'];
};

export const OutlinedInputComponent: MuiOutlinedInputComponent = {
  styleOverrides: {
    root: {
      backgroundColor: '#F6F7F8',
      fontSize: '16px',
      lineHeight: '22px',
      color: '#000000',
      '&:hover:not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px',
        borderColor: '#A2A7AE',
      },
      '&:hover&.Mui-disabled  .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      borderRadius: '6px',
      '&.MuiInputBase-fullWidth': {
        width: '100%',
      },
      '&.Mui-disabled': {
        backgroundColor: '#F2EDEB',
        color: '#D7CAC4',
        cursor: 'not-allowed',
      },
      '&.Mui-error': {
        backgroundColor: `${CIColors.Error}10`,
        '&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
          border: '1px solid',
          borderColor: CIColors.Error,
        },
      },
    },
    input: {
      padding: '13px 16px',
      height: 'auto',
    },
    adornedStart: {
      '& .MuiOutlinedInput-input': {
        paddingLeft: 0,
      },
    },
    inputMultiline: {
      padding: '0px',
      lineHeight: '22px',
    },
    notchedOutline: {
      borderWidth: '0px',
    },
    focused: {},
    disabled: {},
    error: {},
  },
};
